<template>
  <div>
    <div class="col form-group mt-3">
      <label
        class="mb-1"
        :style="
          template.secondaryTheme
            ? 'color: white !important; margin-bottom:5px; font-weight: light !important;'
            : ''
        "
      >
        {{ translation.genderIdentity }}
      </label>

      <div class="gender-div-gap">
        <div class="gender-div">
          <input
            id="masculino"
            v-model="obj.gender"
            class="form-check-input"
            style="margin-bottom: 5px"
            type="radio"
            name="gender"
            value="M"
          />
          <label
            for="masculino"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ translation.male }}
          </label>
        </div>

        <div class="gender-div">
          <input
            id="feminino"
            class="form-check-input"
            v-model="obj.gender"
            type="radio"
            name="gender"
            value="F"
          />
          <label
            for="feminino"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ translation.female }}
          </label>
        </div>

        <div class="gender-div">
          <input
            id="outro"
            class="form-check-input"
            v-model="obj.gender"
            type="radio"
            name="gender"
            value="N"
          />
          <label
            for="outro"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ translation.other }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  name: 'Gender',
  props: {
    validate: Boolean,
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    obj: {},
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    translation() {
      if (this.obj.passport) {
        return {
          attention: 'Attention',
          genderIdentity: 'Gender Identity',
          male: 'Male',
          female: 'Female',
          other: 'Other',
          alertGender: 'You must inform your gender.',
        }
      }
      return {
        attention: 'Atenção',
        genderIdentity: 'Identidade de Gênero',
        male: 'Masculino',
        female: 'Feminino',
        other: 'Outro',
        alertGender: 'É necessário informar seu gênero.',
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Creates a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    if (!this.obj.gender) this.obj.gender = 'g'
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.attention,
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.gender || this.obj.gender === 'g') {
        hasErrors = true
        this.addRegistrationError({
          msg: this.translation.alertGender,
        })
        this.toastMessage = this.translation.alertGender
        this.makeToast('warning')
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
}
</script>

<style scoped>
.form-check-input {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-right: 8px;
  align-self: initial;
  float: left;
  cursor: pointer;
}

.form-check-input:focus {
  outline: none;
}

.form-check-input:checked {
  background-color: var(--input-color);
}

.left-align {
  text-align: left;
}
.form-radio label {
  margin-bottom: 0.5;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
